import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { PrimeIcons } from 'primeng/api';

@Component({
  selector: 'elx-toastr',
  standalone: true,
  imports: [ButtonModule, CommonModule],
  template: `
    <div class="custom-toast" [ngClass]="toastType">
      <div class="toast-icon">
        <i [class]="getIconClass()"></i>
      </div>
      <div class="toast-content">
        <strong>{{ toastPackage.title }}</strong>
        <p>{{ toastPackage.message }}</p>
      </div>
      <p-button
        [icon]="PrimeIcons.TIMES"
        [text]="true"
        [rounded]="true"
        size="small"
        class="close-btn"
        (onClick)="closeToast($event)"
      >
      </p-button>
    </div>
  `,
})
export class ToastrComponent extends Toast {
  PrimeIcons = PrimeIcons;

  constructor(
    toastrService: ToastrService,
    public override toastPackage: ToastPackage
  ) {
    super(toastrService, toastPackage);
  }

  get toastType(): string {
    const type = this.toastPackage.toastType;
    if (type.includes('success')) return 'success';
    if (type.includes('error')) return 'error';
    if (type.includes('warning')) return 'warning';
    if (type.includes('info')) return 'info';
    return '';
  }

  getIconClass(): string {
    switch (this.toastType) {
      case 'success':
        return PrimeIcons.CHECK;
      case 'error':
        return PrimeIcons.TIMES;
      case 'info':
        return PrimeIcons.INFO_CIRCLE;
      case 'warning':
        return PrimeIcons.EXCLAMATION_TRIANGLE;
      default:
        return PrimeIcons.BELL;
    }
  }

  closeToast(event: MouseEvent) {
    event.stopPropagation();
    this.toastrService.remove(this.toastPackage.toastId);
  }
}
